<template>
  <div id="app">
    <router-view />
    <div v-if="loggedIn">
      <button class="button-primary button-round" @click="signOut()">
        {{ $t("Log out") }}
      </button>
    </div>
    <div
      style="font-size: 10px; color: white;"
      v-show="!showdebug"
      @click="showdebug = true"
    >
      Alpha debug info
    </div>
    <div style="font-size: 10px;" v-show="showdebug" @click="showdebug = false">
      <div>
        loggedIn
        {{ loggedIn }}
      </div>
      <div>
        userData
        {{ userData }}
      </div>
      <div>
        mailToBeSent
        {{ mailToBeSent }}
      </div>
      <div>
        mailData
        {{ mailData }}
      </div>
      <div>
        {{ $t("Hello!") }}
      </div>
    </div>
  </div>
</template>
<script>
import { signOut } from "@/utils/firebase";
import { mapState } from "vuex";

export default {
  name: "App",

  components: {},

  data() {
    return {
      showdebug: false,
    };
  },

  computed: {
    ...mapState("userData", ["loggedIn", "user", "userData"]),
    ...mapState("mail", ["mailToBeSent", "mailData"]),
  },

  methods: {
    signOut,
  },

  mounted() {},
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
